<template>
  <v-layout
    class="mt-4"
    wrap
  >
    <v-flex
      v-if="isCurrentEdition"
      xs12
    >
      <v-layout
        class="align-stretch mb-3"
        align-end
        :wrap="smAndDownScreen"
      >
        <v-flex
          lg3
          md4
          sm12
          class="pr-3"
        >
          <h3 class="display-2 display-2_dark mb-2">
            {{ $t('family_card.enteranse.editions') }}
          </h3>
          <a
            v-if="false"
            class="small fw-400"
          >{{ $t('buttons.search_alikes_families_again') }}</a>
        </v-flex>
        <v-flex
          lg9
          md8
          sm12
          :class="[smAndDownScreen ? 'pr-3' : 'px-3']"
        >
          <v-layout
            v-if="participPrevEdition"
            class="enteranse-info align-center mb-3"
          >
            <v-flex shrink>
              <v-icon
                large
                color="green"
              >
                check_circle
              </v-icon>
            </v-flex>
            <v-flex
              shrink
              ml-2
            >
              <p class="fw-600 mb-0 display-2_dark">
                {{ $t('alikes_families.p_e.entrance_checked') }}
              </p>
            </v-flex>
          </v-layout>

          <CheckPreviousEditionsButton :visible="!isChecked && canCheckPrevEditions" />

          <v-layout
            v-if="previousEditionsList && previousEditionsList.length > 0"
            wrap
            class="mb-4"
          >
            <v-flex
              v-for="(mEdition, index) in previousEditionsList"
              :key="index"
              xs12
              shrink
              class="mr-3"
            >
              <v-layout align-center>
                <router-link
                  :to="{ name: 'family-card', params: { id: mEdition.family_edition_id } }"
                  class="font-weight-bold"
                  target="_blank"
                  :disabled="!mEdition.is_allowed"
                  :class="mEdition.edition === edition.name ? 'sz_red--text' : ''"
                >
                  {{ $t('label.edition') }} {{ mEdition.edition }}
                </router-link>
                <v-icon
                  v-if="showWarnIcon(mEdition)"
                  color="sz_red"
                  size="16"
                  class="ml-2"
                >
                  error_outline
                </v-icon>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="showNotAllowedNotification"
              xs12
            >
              <v-layout
                align-center
                mt-3
              >
                <v-icon
                  color="sz_red"
                  size="32"
                >
                  error_outline
                </v-icon>
                <p
                  class="f-1 mb-0 ml-2 fw-600 sz_grafit--text"
                  v-html="$t('message.not_allowed_previous_edition_families')"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider />
    </v-flex>
    <v-flex xs12>
      <v-layout
        class="mt-3 align-stretch enteranse-info"
        :wrap="smAndDownScreen"
      >
        <v-flex
          lg3
          md4
          sm12
          class="pr-3"
        >
          <h3 class="display-2 display-2_dark mb-2">
            {{ $t('family_card.enteranse.family_application') }}
          </h3>
        </v-flex>
        <v-flex
          lg9
          md8
          sm12
          :class="[smAndDownScreen ? 'pr-3' : 'px-3']"
        >
          <div v-if="isSourceOfAssigment">
            <h4 class="display-1 display-1_dark mb-2">
              {{ $t('family_card.enteranse.source_of_assignment') }}
            </h4>
            <ul class="list mb-3">
              <li v-if="isSourceVisible">
                {{ $t('family_card.enteranse.source_name') }}
              </li>
              <li v-if="addedPreviousEdition || sourceImporter">
                {{ $t('family_card.enteranse.prev_edition_source') }}
              </li>
            </ul>
          </div>
          <div v-if="supportCriteria && supportCriteria.length > 0">
            <h4 class="display-1 display-1_dark mb-2">
              {{ $t('family_card.enteranse.help_criteria') }}
            </h4>
            <ul class="list mb-3">
              <li
                v-for="(criteria, index) in supportCriteria"
                :key="index"
              >
                {{ criteria.name }}
              </li>
            </ul>
          </div>
          <div>
            <h4 class="display-1 display-1_dark mb-2">
              {{ $t('family_card.enteranse.note') }}
            </h4>
            <div
              v-if="description"
              class="mb-3"
            >
              {{ description }}
            </div>
            <EditDescription
              v-if="canEditNote"
              :note-value="description"
              :family-id="familyId"
            />
          </div>
          <h4
            v-if="name || phoneNumber"
            class="display-1 display-1_dark mb-2"
          >
            {{ $t('family_card.enteranse.source') }}
          </h4>
          <p
            v-if="name"
            class="mb-0"
            :class="[{ 'mb-2': !phoneNumber }]"
          >
            <span class="fw-600">{{ $t('label.custom_option_label') | addColons }}</span>
            {{ name }}
            <span v-if="descriptionName">, {{ descriptionName }}</span>
          </p>
          <p
            v-if="phoneNumber"
            class="mb-2"
          >
            <span class="fw-600">{{ $t('similar_families.phone') }}</span> {{ phoneNumber | phone }}
          </p>
          <div v-if="showConsentFiles">
            <h4 class="display-1 display-1_dark mb-2">
              {{ $t('family_card.consent') }}
            </h4>
            <v-layout
              class="mb-3"
              align-center
            >
              <v-flex
                v-if="consentFiles && consentFiles.length > 0"
                shrink
              >
                <v-layout
                  align-start
                  justify-start
                >
                  <v-flex
                    v-for="(consent, index) in consentFiles"
                    :key="index"
                    shrink
                    mr-2
                    @click.prevent="openConsentFile($route.params.id, consent, true)"
                  >
                    <BaseIcon
                      class="clickable"
                      width="32"
                      height="32"
                    >
                      <PdfIcon :icon-color="$vuetify.theme.sz_violet" />
                    </BaseIcon>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                v-if="canEditConsent"
                shrink
              >
                <v-layout
                  align-start
                  justify-start
                >
                  <v-flex class="mb-1">
                    <a @click="editConsents">{{ $t('label.manage') }}</a>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <file-upload
        ref="upload"
        v-model="files"
        class="d-none"
        :accept="acceptInitialConsent"
        :drop="false"
        required
        input-id="files"
        :multiple="false"
        :maximum="maxQuantity"
        :size="maxSize"
        @input-filter="inputFilesFilterWithAudio"
        @input-file="inputFile"
      />
    </v-flex>
    <AppModal
      :close-button="false"
      :visible="editConsentsModal"
      :persistent="true"
      @close="closeEditConsents"
    >
      <template slot="title">
        <h2 class="display-3 display-3_dark text-xs-left">
          {{ $t('family_card.manage_consent.title') }}
        </h2>
      </template>
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('family_card.manage_consent.text') }}
        </p>
        <v-layout
          align-start
          justify-start
          mt-3
          wrap
        >
          <v-flex
            v-for="(consent, index) in consentFiles"
            :key="index"
            mb-3
            xs12
          >
            <v-layout align-center>
              <v-flex xs8>
                <a
                  class="layout align-center"
                  @click="openConsentFile($route.params.id, consent, true)"
                >
                  <BaseIcon
                    class="clickable"
                    width="32"
                    height="32"
                  >
                    <PdfIcon :icon-color="$vuetify.theme.sz_violet" />
                  </BaseIcon>
                  <span class="ml-2">{{ index + 1 }}. {{ $t('forms_steps.consent') }}:
                    {{ formatDate(consent?.created_at, {
                      useIntl: true
                    }) }} </span>
                </a>
              </v-flex>
              <v-spacer />
              <v-flex
                shrink
                @click="replaceConsent(consent, $event)"
              >
                <v-progress-circular
                  v-if="replaceId === consent?.uri && isLoading"
                  ml-3
                  color="sz_violet"
                  :size="15"
                  indeterminate
                />
                <a
                  v-else
                  class="layout align-center"
                  :class="isLoading ? 'disabled' : ''"
                >
                  <label for="files">{{ $t('buttons.replace') }}</label>
                </a>
              </v-flex>
              <v-flex
                v-if="consentFiles?.length > 1"
                shrink
                ml-3
                @click.prevent="removeConsent(consent, $event)"
              >
                <a
                  class="layout align-center"
                  :class="isLoading ? 'disabled' : ''"
                >
                  <baseIcon
                    :width="18"
                    :height="18"
                    class="mr-1"
                  >
                    <cartIcon :icon-color="$vuetify.theme.sz_violet" />
                  </baseIcon>
                  <span>{{ $t('buttons.delete') }}</span>
                </a>
              </v-flex>
            </v-layout>
            <v-divider class="mt-2" />
          </v-flex>
          <v-flex v-if="showAddNewFile">
            <v-layout>
              <v-spacer />
              <v-flex shrink>
                <a
                  class="layout align-center"
                  :class="isLoading ? 'disabled' : ''"
                  @click="addNewFile($event)"
                >
                  <label for="files">{{ $t('family_card.manage_consent.add') }}</label>
                </a>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div
          v-if="error"
          class="v-message mt-3 text-xs-center"
        >
          <div class="v-messages__message mb-0">
            {{ error }}
          </div>
        </div>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="mt-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-end="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :loading="isLoading"
              :disabled="isLoading"
              @click="closeEditConsents"
            >
              {{ $t('buttons.ok') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <ConfirmDialog
      :visible="deleteConfirm"
      :title="$t('family_card.manage_consent.confirm_remove')"
      @dialog="deleteConfirm = $event"
      @response-ok="removeFile"
    />
  </v-layout>
</template>

<script>
import CheckPreviousEditionsButton from '@/components/familyCard/CheckPreviousEditionsButton';
import EditDescription from '@/components/familyCard/EditDescription';
import ConfirmDialog from '@/components/widgets/ConfirmDialog';
import filters from '@/constants/filters';
import permissions from '@/constants/permissions';
import statusesId from '@/constants/statusesId';
import BaseIcon from '@/icons/BaseIcon';
import CartIcon from '@/icons/CartIcon';
import PdfIcon from '@/icons/PdfIcon';
import consent from '@/mixins/consent';
import fileUploadMixin from '@/mixins/fileUpload';
import fileUpload from 'vue-upload-component';
import AppModal from '@/components/widgets/AppModal.vue';
import { formatDate } from '@/utils/formatDate';

export default {
    name: 'EnteranseInfo',
    components: {
        CheckPreviousEditionsButton,
        ConfirmDialog,
        CartIcon,
        AppModal,
        PdfIcon,
        BaseIcon,
        fileUpload,
        EditDescription
    },
    filters: {
        ...filters
    },
    mixins: [consent, fileUploadMixin],
    props: {
        description: {
            required: true,
            default: null
        },
        reporter: {
            required: true,
            default: null
        },
        source: {
            required: true,
            default: null
        },
        supportCriteria: {
            required: true,
            default: null
        },
        previousEditions: {
            required: true,
            default: () => {
                return [];
            }
        },
        familyToAcceptEdition: {
            required: true
        },
        edition: {
            required: true
        },
        consentFiles: {
            required: true
        },
        participPrevEdition: {
            default: false
        },
        fromOffice: {
            required: true
        },
        isChecked: {
            default: true
        }
    },
    data: () => ({
        statusesId,
        permissions,
        editConsentsModal: false,
        files: [],
        replaceId: null,
        removeId: null,
        error: null,
        isLoading: false,
        deleteConfirm: false,
        addNewFileFlag: false,
        forbiddenStatusesForEditConsent: [
            statusesId.DISABLED,
            statusesId.PUBLISHED,
            statusesId.HAS_GIFTGIVER,
            statusesId.GIFT_GIVING_REPORT_DESCRIBED,
            statusesId.GIFT_CHECKING,
            statusesId.GIFT_GIVING_REPORT_AREA_REACH,
            statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH,
            statusesId.GIFT_GIVING_REPORT_BACK_AREA_REACH,
            statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH,
            statusesId.GIFT_GIVING_REPORT_SEND
        ],
        familyEditionViewPermission: null,
        hasPermissionForFamilyEditionEdit: null,
        editConsentPermission: null,
        editConsentPermissionPrivileged: null
    }),
    computed: {
        smAndDownScreen () {
            return this.$vuetify.breakpoint.smAndDown;
        },
        reporterCategory () {
            if (this.reporter === null) {
                return null;
            }
            return this.reporter.category.name;
        },
        sourceCategory () {
            if (this.source == null) {
                return null;
            }
            if (this.source.category == null) {
                return null;
            }
            return this.source.category.name;
        },
        name () {
            return this.reporterCategory || this.sourceCategory;
        },
        descriptionName () {
            return this.reporterDescriptionCategory || this.sourceDescriptionCategory;
        },
        reporterDescriptionCategory () {
            if (this.reporter == null) {
                return null;
            }
            return this.reporter.corpo_name;
        },
        sourceDescriptionCategory () {
            if (this.source == null) {
                return null;
            }
            if (this.source.category && this.source.category.is_allowed_additional_data === false) {
                return null;
            }
            return this.source.name;
        },
        sourceNumber () {
            if (this.source == null) {
                return null;
            }
            return this.source.phone_number;
        },
        categoryNumber () {
            // hide reporter phone number
            return null;
        },
        phoneNumber () {
            return this.categoryNumber || this.sourceNumber;
        },
        isSourceVisible () {
            return (
                this.sourceImporter ||
        this.fromOffice === true ||
        (this.addedPreviousEdition && this.fromOffice === true)
            );
        },
        sourceImporter () {
            return this.source && this.source.name === 'Importer';
        },
        addedPreviousEdition () {
            const createdAtPrevious = this.familyToAcceptEdition && this.familyToAcceptEdition.name;
            const createdAtCurrent = this.edition && this.edition.name;

            return parseInt(createdAtPrevious) < parseInt(createdAtCurrent);
        },
        familyId () {
            return parseInt(this.$route.params.id);
        },
        previousEditionsList () {
            return this.previousEditions.filter((el) => {
                return el.family_edition_id !== this.familyId;
            });
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        isSourceOfAssigment () {
            return this.isSourceVisible || this.addedPreviousEdition;
        },
        showConsentFiles () {
            return (this.consentFiles && this.consentFiles.length > 0) || this.editConsentPermissions;
        },
        showAddNewFile () {
            return (this.consentFiles && this.consentFiles.length) < this.maxQuantity;
        },
        currentFamilyStatus () {
            return this.$store.getters['family/getFamily'].status.family_edition_status_id;
        },
        editConsentPermissions () {
            return this.editConsentPermission && this.editConsentPermissionPrivileged;
        },
        canEditConsent () {
            if (this.editConsentPermissionPrivileged && this.isCurrentEdition) {
                return true;
            }
            return (
                !this.forbiddenStatusesForEditConsent.includes(this.currentFamilyStatus) &&
        this.editConsentPermission &&
        this.isCurrentEdition
            );
        },
        showNotAllowedNotification () {
            return (
                this.previousEditionsList.some((el) => !el.is_allowed) && this.familyEditionViewPermission
            );
        },
        canEditNote () {
            return (
                this.hasPermissionForFamilyEditionEdit &&
        [
            this.statusesId.CREATING_DESCRIPTION,
            this.statusesId.CREATING_FIRST_SHEET,
            this.statusesId.CREATING_SECOND_SHEET,
            this.statusesId.NOT_ATTRIBUTED
        ].includes(this.currentFamilyStatus)
            );
        },
        canCheckPrevEditions () {
            return ![this.statusesId.DISABLED].includes(this.currentFamilyStatus);
        }
    },
    created () {
        this.$store.dispatch('auth/hasPermission', this.permissions.FAMILY_EDITION_EDIT).then((res) => {
            this.hasPermissionForFamilyEditionEdit = res;
        });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.FAMILY_CONSENT_EDIT)
            .then((result) => {
                this.editConsentPermission = result;
            });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.FAMILY_CONSENT_EDIT_PRIVILEGED)
            .then((result) => {
                this.editConsentPermissionPrivileged = result;
            });
        this.$store.dispatch('auth/hasPermission', this.permissions.FAMILY_EDITION_VIEW).then((res) => {
            this.familyEditionViewPermission = res;
        });
    },
    methods: {
        formatDate,
        editConsents () {
            this.editConsentsModal = true;
        },
        closeEditConsents () {
            this.editConsentsModal = false;
        },
        addNewFile ($event) {
            if ((this.addNewFileFlag === true && this.isLoading) || this.isLoading) {
                $event.preventDefault();
                return;
            }
            this.addNewFileFlag = true;
        },
        replaceConsent (consent, $event) {
            if (this.isLoading) {
                $event.preventDefault();
                return;
            }
            this.replaceId = consent.uri;
        },
        removeConsent (consent, $event) {
            if (this.isLoading) {
                $event.preventDefault();
                return;
            }
            this.removeId = consent.uri;
            this.deleteConfirm = true;
        },
        removeFile () {
            this.isLoading = true;
            this.deleteConfirm = false;
            this.$store
                .dispatch('familyData/removeFamilyConsent', {
                    familyId: this.familyId,
                    uri: this.removeId,
                    isPrivileged: this.editConsentPermissionPrivileged
                })
                .then(({ data }) => {
                    this.$store.commit('family/setFamily', data.data);
                })
                .finally(() => {
                    this.removeId = null;
                    this.isLoading = false;
                });
        },
        inputFile (newFile) {
            if (this.replaceId != null) {
                this.isLoading = true;
                this.$store
                    .dispatch('familyData/replaceFamilyConsent', {
                        familyId: this.familyId,
                        uri: this.replaceId,
                        files: this.files,
                        isPrivileged: this.editConsentPermissionPrivileged
                    })
                    .then(({ data }) => {
                        this.$store.commit('family/setFamily', data.data);
                    })
                    .finally(() => {
                        this.clearFiles();
                        this.replaceId = null;
                    });
            } else if (this.addNewFileFlag) {
                this.isLoading = true;
                this.$store
                    .dispatch('familyData/addFamilyConsent', {
                        familyId: this.familyId,
                        files: this.files,
                        isPrivileged: this.editConsentPermissionPrivileged
                    })
                    .then(({ data }) => {
                        this.$store.commit('family/setFamily', data.data);
                    })
                    .finally(() => {
                        this.addNewFileFlag = false;
                        this.clearFiles();
                    });
            }
        },
        clearFiles () {
            this.files = [];
            this.isLoading = false;
        },
        showWarnIcon (prevEdition) {
            return !prevEdition.is_allowed && this.edition.name === prevEdition.edition;
        }
    }
};
</script>

<style scoped></style>
